<template>
  <div>
    <el-form style="margin-right: 30px" :model="addEditForm" :rules="addEditRules" ref="addEditForm" label-width="100px" class="demo-ruleForm">
      <el-row>
        <el-col :span="16">
          <el-form-item label="菜品名称" prop="name">
            <el-input v-model="addEditForm.name" placeholder="请输入菜品名称"></el-input>
          </el-form-item>
          <el-form-item label="提供类型" prop="types">
            <el-select v-fixZoom multiple v-model="addEditForm.types" filterable placeholder="请选择" :clearable="false" style="width:100%;" >
              <el-option v-for="item in typeArr" :key="item.index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <div style="width: 90px;margin: auto">
            <el-upload class="avatar-uploader" action="#" :auto-upload="false"
                       :show-file-list="false" :on-exceed="handleExceed" :before-upload="beforeUpload"
                       :on-change="getFile" list-type="picture" :file-list="fileList">
              <img v-if="addEditForm.photoUrl" :src="addEditForm.photoUrl" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
          <div style="font-size: 14px;text-align: center;color: #409EFF">
            <span v-if="addEditObj.isAdd">上传图片</span>
            <span v-else>更新图片</span>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="所属餐厅" prop="restaurantid">
            <el-select v-fixZoom :disabled="!addEditObj.isAdd" v-model="addEditForm.restaurantid" filterable placeholder="请选择" :clearable="false" style="width:100%;" @change="changeRestaurant">
              <el-option v-for="item in restaurants" :key="item.index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="价格" prop="price">
            <el-input type="number" v-model="addEditForm.price" placeholder="请输入价格(元)"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="菜品描述" prop="">
        <el-input v-model="addEditForm.desc" placeholder="请输入菜品描述"></el-input>
      </el-form-item>
      <el-form-item label="所用食材" prop="ingredientIds">
        <div>请勾选所需的食材。</div>
        <div style="height: 240px;overflow-y: auto">
          <el-table ref="multipleTable" height="100%" tooltip-effect="dark" size="mini" border :data="selectIngredientArr" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55" align="center"/>
            <el-table-column label="名称" align="center" prop="name"/>
            <el-table-column label="单位" align="center" prop="name">
              <template slot-scope="scope">
                <span>{{getUnitName(scope.row.unitid)}}</span>
              </template>
            </el-table-column>
            <el-table-column label="数量" prop="name">
              <template slot-scope="scope">
                <el-input size="mini" type="number" v-model="scope.row.val" placeholder="请输入食材数量"></el-input>
                <span style="font-size: 12px;color: #999999">默认为不限数量</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form-item>

      <el-form-item label="营养成分" prop="">
        <table border="1" style="border-collapse: collapse;border: #F5F7FA;">
          <tr>
            <td style="padding: 5px"><span>碳水化合物</span></td>
            <td style="padding: 5px"><el-input style="width: 100%" placeholder="请输入" @blur="blurKal" v-model="addEditForm.CHO"></el-input></td>
            <td style="padding: 5px 15px"><span>克</span></td>
          </tr>
          <tr>
            <td style="padding: 5px"><span>蛋白质</span></td>
            <td style="padding: 5px"><el-input style="width: 100%" placeholder="请输入" @blur="blurKal" v-model="addEditForm.PRO"></el-input></td>
            <td style="padding: 5px 15px"><span>克</span></td>
          </tr>
          <tr>
            <td style="padding: 5px"><span>脂肪</span></td>
            <td style="padding: 5px"><el-input style="width: 100%" placeholder="请输入" @blur="blurKal" v-model="addEditForm.FAT"></el-input></td>
            <td style="padding: 5px 15px"><span>克</span></td>
          </tr>
          <tr>
            <td style="padding: 5px"><span>糖类</span></td>
            <td style="padding: 5px"><el-input style="width: 100%" placeholder="请输入" @blur="blurKal" v-model="addEditForm.SUG"></el-input></td>
            <td style="padding: 5px 15px"><span>克</span></td>
          </tr>
          <tr>
            <td style="padding: 5px"><span>膳食纤维</span></td>
            <td style="padding: 5px"><el-input style="width: 100%" placeholder="请输入" v-model="addEditForm.DF"></el-input></td>
            <td style="padding: 5px 15px"><span>克</span></td>
          </tr>
        </table>
      </el-form-item>
      <el-form-item label="总卡路里" prop="">
        <span>{{ addEditForm.dish_kcal }} kcal</span>
      </el-form-item>
    </el-form>
    <div style="height: 50px">
      <el-row style="margin: 0 20px">
        <el-col :span="12">
          <div class="cancel-btn" @click="closeAddEdit()">
            <span>取消</span>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="send-btn" @click="submitAddEdit('addEditForm')">
            <span>确定</span>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import {uploadimage, adddish, updatedish} from '../../../api/yanglaoyuan'
import {getToken} from '../../../utils/auth'

export default {
  name: 'addEditDishes',
  model: {
    prop: 'addEditShow',
    event: 'change'
  },
  props: {
    addEditObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      restaurants: [], // 餐厅
      ingredientunits: [], // 食材单位
      ingredients: [], // 食材
      selectIngredientArr: [],
      ingredientId: '',
      typeArr: [
        {id: 1, name: '早餐'},
        {id: 2, name: '午餐'},
        {id: 4, name: '晚餐'}
      ],
      fileList: [],
      addEditForm: {
        id: 0,
        eid: 0,
        type: '',
        types: [],
        name: '',
        price: '',
        picture: '',
        desc: '',
        restaurantid: '',
        ingredients: [],
        dynamicTags: [],
        ingredientIds: [],
        photoUrl: '',
        // 营养成分
        CHO: '',
        PRO: '',
        FAT: '',
        DF: '',
        SUG: '',
        dish_kcal: 0
      },
      addEditRules: {
        name: [
          {required: true, message: '请输入菜品名称', trigger: 'blur'}
        ],
        price: [
          {required: true, message: '请输入菜品价格', trigger: 'blur'}
        ],
        types: [
          {required: true, message: '请选择类型', trigger: 'change'}
        ],
        restaurantid: [
          {required: true, message: '请选择餐厅', trigger: 'change'}
        ],
        dynamicTags: [
          {required: true, message: '请选择食材', trigger: 'change'}
        ]
      },
      // 选中数组
      ghs: [],
      addShow: false,
      unitName: ''
    }
  },
  created () {
    this.restaurants = this.addEditObj.restaurants
    this.ingredientunits = this.addEditObj.ingredientunits
    this.ingredients = this.addEditObj.ingredients
    if (this.addEditObj.isAdd) {
      this.addEditForm.eid = this.$store.state.user.LoginResp.entity_id
    } else {
      // console.log(this.addEditObj.row)
      this.addEditForm.id = this.addEditObj.row.id
      this.addEditForm.type = this.addEditObj.row.type
      if (this.addEditObj.row.type === 1) {
        this.addEditForm.types = [1]
      } else if (this.addEditObj.row.type === 2) {
        this.addEditForm.types = [2]
      } else if (this.addEditObj.row.type === 3) {
        this.addEditForm.types = [1, 2]
      } else if (this.addEditObj.row.type === 4) {
        this.addEditForm.types = [4]
      } else if (this.addEditObj.row.type === 5) {
        this.addEditForm.types = [1, 4]
      } else if (this.addEditObj.row.type === 6) {
        this.addEditForm.types = [2, 4]
      } else if (this.addEditObj.row.type === 7) {
        this.addEditForm.types = [1, 2, 4]
      }
      this.addEditForm.name = this.addEditObj.row.name
      this.addEditForm.price = this.addEditObj.row.price
      this.addEditForm.picture = this.addEditObj.row.picture
      this.addEditForm.desc = this.addEditObj.row.desc
      this.addEditForm.restaurantid = this.addEditObj.row.restaurantid
      this.addEditForm.eid = this.addEditObj.row.eid
      this.addEditForm.ingredients = this.addEditObj.row.ingredients
      this.addEditForm.dynamicTags = this.addEditObj.row.ingredients
      let ingredientIds = [] // ingredientIds
      for (let i = 0; i < this.addEditForm.ingredients.length; i++) {
        ingredientIds.push(this.addEditForm.ingredients[i].id)
      }
      this.addEditForm.ingredientIds = ingredientIds
      this.addEditForm.photoUrl = this.addEditForm.picture !== '' ? 'https://jiaold.com/api/v1/web/food/image/' + this.addEditForm.picture + '?token=' + getToken() : ''
      let arr = []
      for (let i = 0; i < this.ingredients.length; i++) {
        if (this.addEditForm.restaurantid === this.ingredients[i].restaurantid) {
          let obj = this.ingredients[i]
          obj.val = ''
          arr.push(obj)
        }
      }
      let nutrients = this.addEditObj.row.nutrients
      this.addEditForm.CHO = nutrients !== '' ? nutrients.CHO : ''
      this.addEditForm.PRO = nutrients !== '' ? nutrients.PRO : ''
      this.addEditForm.FAT = nutrients !== '' ? nutrients.FAT : ''
      this.addEditForm.DF = nutrients !== '' ? nutrients.DF : ''
      this.addEditForm.SUG = nutrients !== '' ? nutrients.SUG : ''
      this.addEditForm.dish_kcal = this.addEditObj.row.dish_kcal
      this.selectIngredientArr = arr
    }
  },
  mounted () {
    if (!this.addEditObj.isAdd) {
      let list = []
      this.selectIngredientArr.forEach((item) => {
        this.addEditForm.dynamicTags.forEach(val => {
          if (val.id === item.id) {
            item.val = parseInt(val.val) === 9999 ? '' : val.val
            list.push(item)
          }
        })
      })
      if (list) {
        list.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row, true)
        })
      }
    }
  },
  methods: {
    handleSelectionChange (selection) {
      // 获取所有选中项的gh(工号)属性的值
      // this.ghs = selection.map(item => item.id)
      this.addEditForm.dynamicTags = selection
      // console.log(selection, this.ghs)
    },
    // 图片
    beforeUpload (file) {
      // console.log(111, file, file.type)
    },
    handleExceed (files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },
    getFile (file, fileList) {
      let types = ['image/png', 'image/jpeg', 'image/jpg']
      if (types.indexOf(file.raw.type) === -1) {
        this.$message.error('上传头像图片只能是 .png .jpeg .jpg 格式!')
        return
      }
      this.$message({message: '正在上传。', type: 'warning', duration: 0})
      uploadimage(file).then(res => {
        this.$message.closeAll()
        this.$message({ message: '成功上传图片', type: 'success' })
        this.addEditForm.picture = res.data.filename
        this.addEditForm.photoUrl = 'https://jiaold.com/api/v1/web/food/image/' + res.data.filename + '?token=' + getToken()
      }).catch(() => {
        this.$message.closeAll()
        this.$message({ message: '上传图片失败', type: 'error' })
        this.addEditForm.photoUrl = ''
      })
    },
    getUnitName (id) {
      let unitName = ''
      for (let i = 0; i < this.ingredientunits.length; i++) {
        if (id === this.ingredientunits[i].id) {
          unitName = this.ingredientunits[i].name
        }
      }
      return unitName
    },
    changeRestaurant (id) {
      let arr = []
      for (let i = 0; i < this.ingredients.length; i++) {
        if (id === this.ingredients[i].restaurantid) {
          let obj = this.ingredients[i]
          obj.val = ''
          arr.push(obj)
        }
      }
      this.selectIngredientArr = arr
      this.addEditForm.dynamicTags = []
      // console.log(this.selectIngredientArr)
    },
    selectIngredient () {
      if (this.addEditForm.restaurantid === '') {
        this.$message({
          message: '请选择餐厅。',
          type: 'warning'
        })
        return
      }
      if (this.selectIngredientArr.length === 0) {
        this.$message({
          message: '该餐厅暂无菜品提供。',
          type: 'warning'
        })
        return
      }
      this.addForm = {
        id: '',
        val: '',
        unitid: '',
        name: ''
      }
      this.unitName = ''
      this.checked = false
      this.addShow = true
    },
    changeItem (id) {
      for (let i = 0; i < this.selectIngredientArr.length; i++) {
        if (id === this.selectIngredientArr[i].id) {
          // console.log(this.selectIngredientArr[i], this.ingredientunits)
          this.addForm.name = this.selectIngredientArr[i].name
          this.addForm.unitid = this.selectIngredientArr[i].unitid
        }
      }
      this.unitName = ''
      for (let i = 0; i < this.ingredientunits.length; i++) {
        if (this.addForm.unitid === this.ingredientunits[i].id) {
          this.unitName = this.ingredientunits[i].name
        }
      }
    },
    changeCheck (val) {
      if (val) {
        this.addForm.val = 9999
      } else {
        this.addForm.val = ''
      }
    },
    selectIngredientEnd (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let isHave = false
          for (let i = 0; i < this.addEditForm.dynamicTags.length; i++) {
            if (this.addForm.id === this.addEditForm.dynamicTags[i].id) {
              isHave = true
              this.$confirm('已选过食材, 是否替换已选食材?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'info'
              }).then(() => {
                this.addEditForm.dynamicTags[i] = this.addForm
                this.addShow = false
              })
            }
          }
          if (!isHave) {
            this.addEditForm.dynamicTags.push(this.addForm)
            this.addShow = false
          }
        }
      })
    },
    handleClose (id) {
      let index = 0
      for (let i = 0; i < this.addEditForm.dynamicTags.length; i++) {
        if (id === this.addEditForm.dynamicTags[i].id) {
          break
        }
        index++
      }
      this.addEditForm.dynamicTags.splice(index, 1)
      // console.log(this.addEditForm.dynamicTags)
    },
    changeIngredient (ids) {
      // console.log(ids)
      let ingredients = []
      let arr = this.ingredients
      for (let i = 0; i < ids.length; i++) {
        for (let j = 0; j < arr.length; j++) {
          if (ids[i] === arr[j].id) {
            let obj = {
              id: arr[j].id,
              val: 0,
              unitid: arr[j].unitid
            }
            ingredients.push(obj)
          }
        }
      }
      this.addEditForm.ingredients = ingredients
    },
    blurKal () {
      let val = 0
      if (this.addEditForm.SUG !== '') {
        val = val + parseFloat(this.addEditForm.SUG) * 4
      }
      if (this.addEditForm.CHO !== '') {
        val = val + parseFloat(this.addEditForm.CHO) * 4
      }
      if (this.addEditForm.PRO !== '') {
        val = val + parseFloat(this.addEditForm.PRO) * 4
      }
      if (this.addEditForm.FAT !== '') {
        val = val + parseFloat(this.addEditForm.FAT) * 9
      }
      this.addEditForm.dish_kcal = val
    },
    closeAddEdit () {
      this.$emit('change', false)
    },
    submitAddEdit (formName) {
      this.$refs[formName].validate((valid) => {
        let nutrients = {
          CHO: this.addEditForm.CHO,
          PRO: this.addEditForm.PRO,
          FAT: this.addEditForm.FAT,
          DF: this.addEditForm.DF,
          SUG: this.addEditForm.SUG
        }
        let ingredients = []
        for (let i = 0; i < this.addEditForm.dynamicTags.length; i++) {
          let obj = {
            id: this.addEditForm.dynamicTags[i].id,
            val: this.addEditForm.dynamicTags[i].val === '' ? 9999 : parseFloat(this.addEditForm.dynamicTags[i].val),
            unitid: this.addEditForm.dynamicTags[i].unitid
          }
          ingredients.push(obj)
        }
        // console.log(ingredients)
        if (valid) {
          let sendtype = 0
          for (let i = 0; i < this.addEditForm.types.length; i++) {
            sendtype = sendtype + this.addEditForm.types[i]
          }
          if (this.addEditObj.isAdd) {
            let data = {
              'type': sendtype,
              'name': this.addEditForm.name,
              'price': parseFloat(this.addEditForm.price),
              'picture': this.addEditForm.picture,
              'desc': this.addEditForm.desc,
              'restaurantid': this.addEditForm.restaurantid,
              'eid': this.addEditForm.eid,
              'ingredients': ingredients,
              dish_nutrients: JSON.stringify(nutrients),
              dish_kcal: this.addEditForm.dish_kcal + ''
            }
            // console.log(data)
            adddish(data).then(res => {
              this.$notify({title: '成功', message: '成功新增菜品', type: 'success', duration: 2000})
              this.$emit('updateTable')
              this.$emit('change', false)
            })
          } else {
            let data = {
              'id': this.addEditForm.id,
              'type': sendtype,
              'name': this.addEditForm.name,
              'price': parseFloat(this.addEditForm.price),
              'picture': this.addEditForm.picture,
              'desc': this.addEditForm.desc,
              'restaurantid': this.addEditForm.restaurantid,
              'eid': this.addEditForm.eid,
              'Ingredients': ingredients,
              dish_nutrients: JSON.stringify(nutrients),
              dish_kcal: this.addEditForm.dish_kcal + ''
            }
            updatedish(data).then(res => {
              this.$notify({title: '成功', message: '成功编辑菜品', type: 'success', duration: 2000})
              this.$emit('updateTable')
              this.$emit('change', false)
            })
          }
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/addEditDishes.vue